export const getFallbackConfigurationUrl = (providerId: string) =>
	`/plugins/servlet/upm#manage/${providerId}`;

export const BITBUCKET_APP_ID = 'bitbucket';
const AZURE_DEVOPS_FOR_JIRA_APP_ID = 'azure-devops-for-jira';
const GITHUB_DEV_APP_ID = 'com.github.integration.development';
export const GITHUB_APP_ID = 'com.github.integration.production';
const GITHUB_STG_APP_ID = 'com.github.integration.staging';
export const GITLAB_APP_ID = 'gitlab-jira-connect-gitlab.com';

const CIRCLE_CI_APP_ID = 'circleci.jira';
export const GIT_INTEGRATION_APP_ID = 'com.xiplink.jira.git.jira_git_plugin';
const HARNESS_CI_APP_ID = 'com.harness.ci.plugin.jira';
const JENKINS_APP_ID = 'com.atlassian.jenkins-for-jira';
const JFROG_APP_ID = 'jfrog-artifactory-saas-integration';
const OCTOPUS_DEPLOY_APP_ID = 'com.octopus.jiraconnectapp.production';
const STACK_HAWK_APP_ID = 'stackhawk-jira-connect-prod';
const JSM_APP_ID = 'com.plugins4people.jsd.jsd-config-importer';
const SNYK_APP_ID = 'snyk.in.jira';
const SNYK_STG_APP_ID = 'jira-devops-security-app-stg';
const STACKHAWK_APP_ID = 'stackhawk-jira-connect-prod';
const MEND_APP_ID = 'WhiteSource-Jira-Cloud';
const LACEWORK_APP_ID = 'lacework-vuln-jira-connect';
const JFROG_SECURITY_APP_ID = 'jfrog.security.jiraSecurityInfoProvider';
const SYSDIG_APP_ID = 'sysdigAppKey';

// Design
const FIGMA_APP_ID = 'com.figma.jira-add-on-dev';

export const FULLY_SUPPORTED_APPS = [
	BITBUCKET_APP_ID,
	GITHUB_APP_ID,
	GITHUB_STG_APP_ID,
	SNYK_APP_ID,
	SNYK_STG_APP_ID,
];

export const SECURITY_KNOWN_APPS = [
	JFROG_APP_ID,
	STACK_HAWK_APP_ID,
	SNYK_APP_ID,
	SNYK_STG_APP_ID,
	STACKHAWK_APP_ID,
	MEND_APP_ID,
	LACEWORK_APP_ID,
	JFROG_SECURITY_APP_ID,
	SYSDIG_APP_ID,
];

export const KNOWN_APPS = [
	BITBUCKET_APP_ID,
	AZURE_DEVOPS_FOR_JIRA_APP_ID,
	GITHUB_DEV_APP_ID,
	GITHUB_APP_ID,
	GITHUB_STG_APP_ID,
	GITLAB_APP_ID,
	CIRCLE_CI_APP_ID,
	GIT_INTEGRATION_APP_ID,
	HARNESS_CI_APP_ID,
	JENKINS_APP_ID,
	OCTOPUS_DEPLOY_APP_ID,
	JSM_APP_ID,
	FIGMA_APP_ID,
	...SECURITY_KNOWN_APPS,
];

export const isGitHubApp = (appId: string): boolean =>
	[GITHUB_DEV_APP_ID, GITHUB_APP_ID, GITHUB_STG_APP_ID].includes(appId);

export const isBitbucketApp = (appId: string): boolean => appId === BITBUCKET_APP_ID;
